import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {QuestionOptions} from '../../../constants/question-options';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {ProposalFormBase} from '../proposal-form-base/proposal-form-base.component';
import {Proposal} from 'src/app/model/proposal/proposal';
import {ReplaySubject, takeUntil} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {MatSelect} from '@angular/material/select';

@Component({
    selector: 'app-international-program',
    templateUrl: './international-program-form.component.html',
    styleUrls: ['../../../../styles/form-input.scss'],
    providers: [{ provide: ProposalFormBase, useExisting: InternationalProgramFormComponent }],
    standalone: false
})
export class InternationalProgramFormComponent extends ProposalFormBase implements OnInit, OnDestroy {

  @Input() proposalPreviewCountriesWithLocalPolicies: string[];

  public filterCtrlCountry: FormControl<string> = new FormControl<string>('');
  public filteredOptionsCountry: ReplaySubject<string[]> = new ReplaySubject<string[]>(1);
  countryOptions: string[] = [];

  @ViewChild('multiSelect', {static: true}) multiSelect: MatSelect;


  updateProposal(proposal: Proposal): void {
    proposal.proposalInformation.countriesWithLocalPolicies = this.formGroup.value.countryCodes;
  }

  autoFillForTransmission(proposal: Proposal): void {
    if (proposal.proposalInformation != null) {
      this.formGroup.controls.countryCodes.patchValue(proposal.proposalInformation.countriesWithLocalPolicies);
    }
  }

  autoFillForEdit(proposal: Proposal) {
    if (proposal.proposalInformation != null) {
      this.formGroup.controls.localPoliciesNeeded.patchValue(
        proposal.proposalInformation.countriesWithLocalPolicies != null &&
        proposal.proposalInformation.countriesWithLocalPolicies.length > 0
      );
      this.formGroup.controls.countryCodes.patchValue(proposal.proposalInformation.countriesWithLocalPolicies);
    }
  }

  QuestionOptions = QuestionOptions;

  constructor(private readonly fb: FormBuilder, private readonly translate: TranslateService) {
    super();
  }

  ngOnInit() {
    this.setupLocalPoliciesNeeded();
    QuestionOptions.countryCodes.forEach(code =>
        this.countryOptions.push(this.translate.instant('countryCodes.' + code))
    );
    this.filteredOptionsCountry.next(this.countryOptions.slice());
    this.filterCtrlCountry.valueChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {
          this.filterCountries(this.filterCtrlCountry.value, this.countryOptions, this.filteredOptionsCountry);
        });
    if (this.proposalPreviewCountriesWithLocalPolicies != null && this.proposalPreviewCountriesWithLocalPolicies.length > 0) {
      this.formGroup.controls.localPoliciesNeeded.patchValue(true);
      this.formGroup.controls.countryCodes.patchValue(this.proposalPreviewCountriesWithLocalPolicies);
    }
  }

  setupLocalPoliciesNeeded() {
    this.formGroup.controls.localPoliciesNeeded.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        if (value) {
          this.formGroup.controls.countryCodes.enable();
        } else {
          this.formGroup.controls.countryCodes.disable();
        }
      });
    this.formGroup.controls.localPoliciesNeeded.updateValueAndValidity();
  }

  formGroup = this.fb.group({
    localPoliciesNeeded: false,
    countryCodes: new FormControl<string[]>([], [Validators.required])
  });

  filterCountries(search: string, options, filtered) {
    if (!options) {
      return;
    }
    if (!search) {
      filtered.next(options.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    filtered.next(
      options.filter(country => country.toLowerCase().indexOf(search) > -1)
    );
  }

  reset() {
    this.formGroup.reset();
  }
}
